
import atlas from '@/components/atlas.vue';
export default {
    components: {},
    name: 'index',
    data() {
        return {
            asyncSource: [],
            total: '',//总页数
            pageSize: 20,//每页显示条目个数
            currentPage: parseInt(this.$route.query.page) || 1,//当前页
            tag_id: this.$route.query.tag_id || 2,//2最热 1最新
        };
    },
    async asyncData({ $global, query, redirect }) {
        if (query.tag_id == undefined) {
            redirect('/')
        }
        const res = await $global.tagWorksList({ page: query.page == undefined ? 1 : query.page, tag_id: query.tag_id })
        return { asyncSource: res.data, total: res.data.workslist.total }
    },
    mounted() {


    },
    watchQuery: ['page'],
    methods: {
        handleCurrentChange(val) {
            this.$router.push({ url: '/gallery_tags', query: { page: val, tag_id: this.$route.query.tag_id } })
        },
    }

}
